<script>
import HomeTop from './components/HomeTop/HomeTop.vue'
import ViewBase from '@/components/ViewBase/ViewBase'
export default {
  name: 'ViewHome',
  extends: ViewBase,
  components: {
    HomeTop
  },
  beforeMount () {
    this.api('/home')
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ViewHome/ViewHome.vue